
export const versionNumber = '5.2.2.0822'; // Release will be auto-injected during build

const myLocation = window.location.toString();
export const productionMode = ['http://localhost:8080/', 'http://192.168.0.14:8080/'].every(str => str !== myLocation);

export const myConsoleLog = (...args) => { if (!productionMode) console.info(...args); };

const determineIOS = () => {
    if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
    } else {
        return navigator.maxTouchPoints &&
            navigator.maxTouchPoints > 2 &&
            /MacIntel/.test(navigator.platform);
    }
};
export const isIOS = determineIOS();
